export enum Status {
  AUTHORITY_REQUESTED = 'AUTHORITY_REQUESTED',
  AUTHORITY_SENT = 'AUTHORITY_SENT',
  AUTHORITY_PENDING = 'AUTHORITY_PENDING',
  AUTHORITY_APPROVED = 'AUTHORITY_APPROVED',
  AUTHORITY_REJECTED = 'AUTHORITY_REJECTED',
  AUTHORITY_SHARED = 'AUTHORITY_SHARED',
  AUTHORITY_ACCEPTED = 'AUTHORITY_ACCEPTED',
  AUTHORITY_INITIATED = 'AUTHORITY_INITIATED',
  AUTHORITY_USER_APPROVED = 'AUTHORITY_USER_APPROVED',
  AUTHORITY_USER_REJECTED = 'AUTHORITY_USER_REJECTED',
  ACTIVE = 'ACTIVE',
  RELEASE_REQUESTED = 'RELEASE_REQUESTED',
  SHARING_RELEASE = 'SR',
  RELEASE_SENT = 'RELEASE_SENT',
  RELEASE_PENDING = 'RELEASE_PENDING',
  RELEASE_APPROVED = 'RELEASE_APPROVED',
  RELEASE_REJECTED = 'RELEASE_REJECTED',
  RELEASE_USER_APPROVED = 'RELEASE_USER_APPROVED',
  RELEASE_USER_REJECTED = 'RELEASE_USER_REJECTED',
  RELEASED = 'RELEASED',
  RELEASE_LATER = 'RL',
  CANCELLED = 'CANCELLED',
  TYPE_SHARE = 'SHARE',
  TYPE_UNSHARE = 'UNSHARE',
  ERROR = 'ERROR',
  CHANGE_REQUEST = 'CR',
  SHARED_AUTHORITY_ACCEPTED = 'SHA',
  CHANGE_SENT = 'CS',
  // need to discuss the code for change rejected
  CHANGE_REJECTED = 'E',
  UNSHARE_ACCEPTED = 'USA',
  SHARING_INITIATED = 'SHI',
  CHANGE_PENDING = 'CP',
  CHANGE_APPROVED = 'CA',
  CHANGE_USER_REJECTED = 'CUR',
  CHANGE_USER_APPROVED = 'CUA',
  CHANGE_DISPATCHER_APPROVED = 'CDA',
  CHANGE_DISPATCHER_REJECTED = 'CDR',
  CHANGE_PROPOSED = 'CPD',
  CHANGE_PROPOSED_PARTIALLY_ACCEPTED = 'CPP',
  CHANGE_PROPOSED_ACCEPTED = 'CPA',
  CHANGE_PROPOSED_REJECTED = 'CPR',
  CHANGE_PROPOSED_CANCELED = 'CPC',
  SHARING_REQUESTED = 'SHR',
  SHARING_REQUEST_REJECTED = 'SRR',
  SHARING_INITIATE_REJECTED = 'SIR',
  UNSHARING_INITIATED = 'USI',
  UNSHARING_REJECTED = 'USR',
  SHARING_AUTHORITY = 'SA',
  AUTHORITY_HIDDEN = 'AUTHORITY_HIDDEN'
}
